import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../redux/initialStoreState";
import { ILead } from "../../../redux/leads/leads.types";
import { useTableV2State } from "../../../components/TableV2/hooks/useTableV2State";
import { Box, Typography, IconButton, Chip } from "@mui/material";
import {
  DataTableV2RowRenderType,
  IDataTableV2Props,
} from "../../../components/TableV2/interfaces/IDataTableV2Props";
import {
  ALLOWED_MODULES,
  LoadState,
  MODULE_IDS,
  MODULE_NAMES,
} from "../../../constants/enums";
import {
  clearLeadsState,
  fetchLeadListStatusCountAsync,
  upsertLeadAsync,
} from "../../../redux/leads/leadsActions";
import { useDispatchWrapper } from "../../../hooks";
import { useNavigate } from "react-router-dom";
import { StandardTableActions } from "../../../components/StandardTableActions/StandardTableActions";
import { CustomChip } from "../../../components/CustomChip";
import { RoleBasedMessages } from "../../../security/RoleBasedComponents/RoleBaseMessages/RoleBaseMessages";
import { DataTableV2 } from "../../../components/TableV2/DataTableV2";
import {
  STANDARD_APP_DATE_FORMAT,
  TABLE_CACHING_KEYS,
} from "../../../constants/constants";
import { StatusRenderer } from "../../../components/ActiveInActiveStatus/ActiveInActiveStatus";
import { ViewLeadDetails } from "./components/ViewLeadDeatils/ViewLeadDetails";
import { Edit } from "@mui/icons-material";
import { EditLeadDetails } from "./components/ViewLeadDeatils/EditLeadDetails";
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import { useBillingCompanyContext } from "../../../providers";
import { CSVNew } from "../../../components/TableV2/preDefinedPlugins/CSVExportV2/CSVNew";
import { api } from "../../../api/api";
import { endPoints } from "../../../constants/endPoints";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { ViewWhatsappDetails } from "../../leads/components/viewWhatsappDetails";
import { useRoles } from "../../../security/RolesProvider/RolesProvider";
import { ViewLeadFoodMenuRightPanel } from "../../leads/LeadFoodMenu/ViewLeadFoodMenuRightPanel";
import { OrderProvider } from "../../Food/MenuAndOrders/OrderMenu/MenuOrder/OrderContext";
import { ViewHistoryDetailsRightPanel } from "../../leads/LeadHistory/viewHistoryDetails";
import DeleteIcon from "@mui/icons-material/Delete";
import HistoryIcon from "@mui/icons-material/History";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { RightPanel } from "../../../components/RightPanel";
import { ManageRoughEstimate } from "../../leads/components/RoughEstimate/RoughEstimate";
import { ContentCopy } from "@mui/icons-material";
import { showMessage } from "../../../redux/messages/messagesActions";
import QuickEditLead from "../../leads/CompactLeadView/QuickEditLead";
import { REACT_APP_NAV_ROUTES } from "../../../router/AppNavigation";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { LeadStatusRenderer } from "../../../components/LeadStatusRenderer/LeadStatusRenderer";
import { useTimezoneFormatter } from "../../../hooks/useTimezoneFormatter";
import { DialerCallButton, DialerCallDialog, useDialerCall } from "../../leads/components/DialerCallButton";

export const LeadsTableByCount: React.FC<{
  statusParam: string;
  monthType: string;
  dateState: { dates: { fromDate: string; toDate: string } };
  whatsappStatus?: boolean;
  triggerDownload?: number;
}> = ({ statusParam, monthType, dateState, whatsappStatus, triggerDownload }) => {
  const { list, totalRecords, loading } = useSelector(
    (storeState: IStoreState) => storeState.leads.list,
  );
  const isInitialLoad = React.useRef(true);

  const tableRef = React.useRef<HTMLDivElement>(null);

  const [selectedLeads, setSelectedLeads] = React.useState<{
    isAllSelected: boolean;
    leads: ILead[];
  }>({
    isAllSelected: false,
    leads: [],
  });
  const dispatch = useDispatchWrapper();
  const { ftDate } = useTimezoneFormatter();
  const navigate = useNavigate();
  const { dialerState, initiateCall, closeDialog } = useDialerCall();
  const historyStatusParmRef = React.useRef("");
  const companyOutlet = useBillingCompanyContext();
  const { roles } = useRoles();

  const accessibleModuleIds = roles
    .filter((module) => module.show_module === 1)
    .map((module) => module.module_key);

  const [openWhatsapp, setOpenWhatsapp] = React.useState<ILead | null>(null);
  const [openHistory, setOpenHistory] = React.useState<ILead | null>(null);
  const [openViewLeadFoodMenuRightPanel, setOpenViewLeadFoodMenuRightPanel] =
    React.useState<ILead | null>(null);
  const [openRoughEstimate, setRoughEstimate] = React.useState<ILead | null>(
    null,
  );

  const {
    state: { searchState, tabs, masterColumnResize, pagination },

    onResizeMasterColumns,
    onPageChange,
    onRowsPerPageChange,
    resetPaginationToInitialPagination,
  } = useTableV2State({
    filtersInitialState: {
      defaultDateRange: "last30Days",
      selectedTab: "-1",
    },
    pagination: {
      pageNumber: 1,
      rowsInPerPage: 10,
      apiFetchRowCount: 11,
      extraFetchFactor: 1,
    },
    cachingFilters: {
      uniqueKey: TABLE_CACHING_KEYS.LEAD_TABLE_COUNT,
    },
  });
  const [openView, setOpenView] = React.useState<ILead | null>(null);
  const [openEdit, setOpenEdit] = React.useState<ILead | null>(null);
  const [openQuickEdit, setOpenQuickEdit] = React.useState<ILead | null>(null);
  // use get-lead-count action

  const fetchList = React.useCallback(() => {
    if (!statusParam) {
      return;
    }
    if (historyStatusParmRef.current !== statusParam) {
      historyStatusParmRef.current = statusParam;
      const isUpdated = resetPaginationToInitialPagination();
      if (isUpdated) {
        return;
      }
    }

    dispatch(
      fetchLeadListStatusCountAsync(
        "list",
        monthType,
        statusParam,
        pagination.pageNumber,
        pagination.rowsInPerPage,
        pagination.apiFetchRowCount,
        searchState,
        companyOutlet.comapny.company_outlet_uuid,
        //  dateState.dates,
      ),
    );
  }, [
    statusParam,
    monthType,
    pagination,
    dateState,
    searchState,
    companyOutlet.comapny.company_outlet_uuid,
    dispatch,
    resetPaginationToInitialPagination,
  ]);

  const fetchAllData = async () => {
    try {
      const apiURL = `${endPoints.leads.statusLead}?remark_needed=true&pageNo=1&pageLimit=10000&itemPerPage=10000&from_date=${dateState.dates.fromDate}&to_date=${dateState.dates.toDate}&status_type=${statusParam}&data_wise=Enquiry_Month&type=list&company_outlet_uuid=${companyOutlet.comapny.company_outlet_uuid}`;

      const res = await api.get(apiURL);
      return res.data?.data.leadList || [];
    } catch (err: any) {
      console.error("Error fetching data: ", err);
      return [];
    }
  };

  React.useEffect(() => {
    if (triggerDownload && triggerDownload > 0) {
      handleDownload();
    }
  }, [triggerDownload]);

  const handleDownload = async () => {
    try {
      const data = await fetchAllData();

      // Convert data to CSV format
      const headers = [
        "Name",
        "Contact No",
        "Event Type",
        "Followup Date",
        "Event Date",
        "Status",
        "Guests",
        "Preferred Venue",
        "Handled By Employee",
        "Created At",
        "Remarks",
      ];

      const csvRows = [headers.join(",")];

      data.forEach((lead: ILead) => {
        const row = [
          lead.name_of_guest || "",
          lead.contact_number_one || "",
          lead.event_type || "",
          lead.followup_date ? ftDate(lead.followup_date) : "",
          lead.function_date ? ftDate(lead.function_date) : "",
          lead.status || "",
          lead.number_of_guests || "",
          lead.preferred_venue || "",
          lead.handled_by_employee || "",
          lead.create_ts ? ftDate(lead.create_ts) : "",
          lead.remarks || "",
        ].map((value) => `"${String(value).replace(/"/g, '""')}"`);

        csvRows.push(row.join(","));
      });

      const csvContent = csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Leads_Report_${new Date().toISOString().split("T")[0]}.csv`,
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading CSV:", error);
    }
  };

  const handleCopyPhoneNumber = async (
    phoneNumber: string,
    _countryCode?: string,
  ) => {
    try {
      await navigator.clipboard.writeText(phoneNumber);
      dispatch(
        showMessage({
          type: "success",
          displayAs: "snackbar",
          message: "Phone number copied to clipboard!",
        }),
      );
    } catch (error) {
      dispatch(
        showMessage({
          type: "error",
          displayAs: "snackbar",
          message: "Failed to copy phone number",
        }),
      );
    }
  };

  const leadsTableProps: IDataTableV2Props = {
    isPagination: true,
    pageNumber: pagination.pageNumber,
    rowsPerPageOptions: pagination.rowsInPerPage,
    extraFetchFactor: pagination.extraFetchFactor,
    isDataLoading: loading !== LoadState.Loaded,

    tableCommandBarProps: {
      preDefinedPlugins: {},
      leftItems: {
        customPlugins: [],
      },
      rightItems: {
        customPlugins: [
          {
            key: "csvExport",
            onRender: (columns, items) => (
              <CSVNew
                columns={[
                  {
                    columnName: "Name",
                    fieldName: "name_of_guest",
                    width: 20,
                  },
                  {
                    columnName: "Contact No",
                    fieldName: "contact_number_one",
                    width: 20,
                  },
                  {
                    columnName: "Event Type",
                    fieldName: "event_type",
                    width: 20,
                  },
                  {
                    columnName: "Followup Date",
                    fieldName: "followup_date",
                    width: 20,
                  },
                  {
                    columnName: "Event Date",
                    fieldName: "function_date",
                    width: 20,
                  },
                  {
                    columnName: "Status",
                    fieldName: "status",
                    width: 20,
                  },
                  {
                    columnName: "Guests",
                    fieldName: "number_of_guests",
                    width: 20,
                  },
                  {
                    columnName: "Preferred Venue",
                    fieldName: "preferred_venue",
                    width: 20,
                  },
                  {
                    columnName: "Handled By Employee",
                    fieldName: "handled_by_employee",
                    width: 20,
                  },

                  {
                    columnName: "Created At",
                    fieldName: "create_ts",
                    width: 20,
                  },
                  {
                    columnName: "Remarks",
                    fieldName: "remark",
                    width: 40,
                  },
                ]}
                onExportButtonClick={fetchAllData}
                filePrefixName="Leads Report"
              />
            ),
          },
        ],
      },
    },

    mobileCommandBarProps: {
      filterComponent: <></>,
    },

    mobileColumns: [
      {
        variant: "template1",
        topBanner: {
          leftColumn: {
            key: "preferred_venue",
            fieldName: "preferred_venue",
            onRowCellRender: (_value: any, row: ILead) => (
              <Chip
                label={row.preferred_venue || "No Venue"}
                size="small"
                sx={{
                  height: 20,
                  fontSize: "0.685rem",
                  fontWeight: 700,
                  bgcolor: row.preferred_venue ? "#e0f2fe" : "#f1f5f9",
                  color: row.preferred_venue ? "#0369a1" : "#64748b",
                  borderRadius: "6px",
                  maxWidth: 160,
                }}
              />
            ),
          },
          rightColumn: {
            key: "event_detail",
            fieldName: "event_time",
            onRowCellRender: (_value: any, row: ILead) => {
              const eventTime = row.event_time || "";
              const eventName =
                row.other_event_name || row.event_name || row.event_type || "";
              const eventDetail = [eventTime, eventName]
                .filter(Boolean)
                .join(" | ");

              return (
                <Typography
                  variant="caption"
                  sx={{
                    color: "#64748b",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                  }}
                >
                  {eventDetail || ""}
                </Typography>
              );
            },
          },
        },
        headingColumn: {
          key: "name_of_guest",
          fieldName: "name_of_guest",
          onRowCellRender: (_value: any, row: ILead) => (
            <Typography
              variant="subtitle1"
              fontWeight={700}
              sx={{ color: "#0f172a", fontSize: "0.95rem", lineHeight: 1.25 }}
            >
              {row.name_of_guest || "Lead"}
            </Typography>
          ),
        },
        rightHeadingColumn: {
          key: "status",
          fieldName: "status",
          onRowCellRender: () => null,
        },
        subSectionColumn: [
          {
            key: "contact_number_one",
            fieldName: "contact_number_one",
            onRowCellRender: (_value: any, row: ILead) => (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  mt: 0.25,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                  <DialerCallButton
                    phoneNumber={`${row.country_code || "+91"}${row.contact_number_one}`}
                    onCall={initiateCall}
                    disabled={dialerState.loading}
                  />
                  <WhatsAppIcon
                    sx={{
                      cursor: "pointer",
                      color: "#25D366",
                      fontSize: { xs: "1.1rem", sm: "1.2rem" },
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenWhatsapp(row);
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#1e293b",
                      fontSize: "0.85rem",
                      fontWeight: 600,
                    }}
                  >
                    {row.country_code || "+91"}
                    {row.contact_number_one}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                  <CustomChip
                    color={
                      row.priority?.toUpperCase() === "HOT"
                        ? "error"
                        : row.priority?.toUpperCase() === "WARM"
                          ? "warning"
                          : "info"
                    }
                    content={row.priority || "COLD"}
                    size="small"
                  />
                  <LeadStatusRenderer
                    status={row.status || ""}
                    actualStatus={row.actual_status || ""}
                  />
                </Box>
              </Box>
            ),
          },
          {
            key: "assigned_and_followup",
            fieldName: "followup_date",
            onRowCellRender: (_value: any, row: ILead) => {
              const assignedUser =
                (row as any).assigned_to || row.handled_by_employee;
              const followupStr = row.followup_date
                ? moment(row.followup_date).format("DD-MMM-YYYY")
                : null;

              return (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    mt: 0.25,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#64748b",
                      fontSize: "0.775rem",
                      fontWeight: 500,
                    }}
                  >
                    {assignedUser ? `Assigned: ${assignedUser}` : ""}
                  </Typography>

                  {followupStr && (
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#0284c7",
                        fontSize: "0.75rem",
                        fontWeight: 600,
                      }}
                    >
                      Follow up: {followupStr}
                    </Typography>
                  )}
                </Box>
              );
            },
          },
        ],
        otherColumns: [
          {
            key: "preferred_venue",
            fieldName: "preferred_venue",
            headerName: "Preferred Venue",
          },
          {
            key: "event_type",
            headerName: "Event Type",
            fieldName: "event_type",
          },
          {
            key: "function_date",
            fieldName: "function_date",
            headerName: "Event Date",
            onRowCellRender: (value, row: ILead) => {
              return ftDate(row.function_date || "");
            },
          },
          {
            key: "followup_date",
            fieldName: "followup_date",
            headerName: "Follow-up Date",
            onRowCellRender: (value, row: ILead) => {
              if (row.followup_date) {
                const finalDate = ftDate(row.followup_date);
                const hasMatched =
                  finalDate === moment().format(STANDARD_APP_DATE_FORMAT);
                return (
                  <Typography sx={{ color: hasMatched ? "error.main" : "" }}>
                    {finalDate}
                  </Typography>
                );
              }
              return "--";
            },
          },
        ],
        actions: [
          {
            name: "Quick Edit",
            icon: <EditNoteIcon />,
            click: (rowData: ILead) => setOpenEdit(rowData),
          },
          {
            name: "Edit",
            icon: <EditIcon />,
            click: (rowData: ILead) =>
              navigate(
                `${REACT_APP_NAV_ROUTES.leads.EventLeads}/manage/${rowData.leads_uuid}/${rowData.multiple_events_uuid}`,
              ),
          },
          {
            name: "History",
            icon: <HistoryIcon />,
            click: (rowData: ILead) => setOpenHistory(rowData),
          },
          ...(accessibleModuleIds.includes(ALLOWED_MODULES.PAYMENT_TRANSACTION)
            ? [
              {
                name: "Rough Estimation",
                icon: <AccountBalanceWalletIcon />,
                click: (rowData: ILead) => setRoughEstimate(rowData),
              },
            ]
            : []),
          {
            name: "Whatsapp",
            icon: <WhatsAppIcon />,
            click: (rowData: ILead) => setOpenWhatsapp(rowData),
          },
          {
            name: "Food Menu",
            icon: <RestaurantMenuIcon />,
            click: (rowData: ILead) =>
              setOpenViewLeadFoodMenuRightPanel(rowData),
          },
        ],
      },
    ],

    masterColumns: [
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        isFirstColumnSticky: true,
        width: "150px",
        onRowCellRender: (value, row: ILead) => {
          return (
            <Box sx={{ display: "flex", gap: 2 }}>
              <StandardTableActions
                commentBoxTypeId={row.leads_uuid as string}
                onQuickEditClick={() => setOpenEdit(row)}
                onEditClick={() =>
                  navigate(
                    `${REACT_APP_NAV_ROUTES.leads.EventLeads}/manage/${row.leads_uuid}/${row.multiple_events_uuid}`,
                  )
                }
                onViewHistoryClick={() => {
                  setOpenHistory(row);
                }}
                onWhatsappClick={() => {
                  setOpenWhatsapp(row);
                }}
              />
            </Box>
          );
        },
      },

      {
        key: "status",
        headerName: "Status",
        fieldName: "status",

        enableSorting: true,

        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        width: "150px",
        onRowCellRender: (value, row: ILead) => {
          return <StatusRenderer status={row.status} />;
        },
      },
      // {
      // 	key: "lead_code",
      // 	headerName: "Lead Code",
      // 	fieldName: "lead_code",

      // 	renderType: DataTableV2RowRenderType.TEXT,

      // 	enableSorting: true,
      // },

      {
        key: "name_of_guest",
        headerName: "Guest Name",
        fieldName: "name_of_guest",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,

        enableSorting: true,
      },
      {
        key: "followup_date",
        headerName: "Followup Date",
        fieldName: "followup_date",
        renderType: DataTableV2RowRenderType.DATE,

        enableSorting: true,
      },
      {
        key: "contact_number_one",
        headerName: "Contact No",
        fieldName: "contact_number_one",
        width: "300px",
        renderType: DataTableV2RowRenderType.TEXT_DARK,
        // exportCellWidth: 30,
        enableSorting: true,
        onRowCellRender: (value, row: ILead) => {
          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <DialerCallButton
                phoneNumber={`${row.country_code || "+91"}${row.contact_number_one}`}
                onCall={initiateCall}
                disabled={dialerState.loading}
              />
              {/* <WhatsAppIcon
                sx={{ cursor: "pointer", color: "#25D366" }}
                onClick={() => setOpenWhatsapp(row)}
              /> */}
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopyPhoneNumber(
                    row.contact_number_one,
                    row.country_code,
                  );
                }}
                sx={{ p: 0.5 }}
                title="Copy phone number"
              >
                <ContentCopy fontSize="small" />
              </IconButton>
              <Typography variant="body2">
                {row.country_code || "+91"}
                {row.contact_number_one}
              </Typography>
            </Box>
          );
        },
      },

      {
        key: "date_of_visit",
        headerName: "Date of Visit",
        fieldName: "date_of_visit",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.DATE_TIME,
        onRowCellRender: (value, row: ILead) => {
          return ftDate(row.date_of_visit);
        },
      },
      {
        key: "event_type",
        headerName: "Event Type",
        fieldName: "event_type",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: ILead) => {
          return (
            <CustomChip color="success" content={row.event_type} size="small" />
          );
        },

        enableSorting: true,
      },

      {
        key: "function_date",
        headerName: "Event Date",
        fieldName: "function_date",
        enableSorting: true,
        renderType: DataTableV2RowRenderType.DATE_TIME,
        onRowCellRender: (value, row: ILead) => {
          return ftDate(row.function_date || "");
        },
      },
      {
        key: "handled_by_employee",
        headerName: "Handled By Employee",
        fieldName: "handled_by_employee",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,

        enableSorting: true,
      },
      {
        key: "remarks",
        headerName: "Remarks",
        fieldName: "remarks",
        renderType: DataTableV2RowRenderType.CUSTOM_RENDER,
        enableSorting: true,
      },
    ],

    rows: list,

    onPageChange: onPageChange,
    onRowsPerPageChange: onRowsPerPageChange,

    masterColumnResize: {
      values: masterColumnResize,
      onResize: onResizeMasterColumns,
    },
  };

  const handleDelete = (row: ILead) => {
    if (row.leads_uuid) {
      dispatch(
        upsertLeadAsync(
          {
            ...row,
            is_archived: 1,
          },
          row,
          true,
          false,
          (isSuccess) => {
            if (isSuccess) {
              fetchList();
            }
          },
        ),
      );
    }
  };

  const handleCloseHistory = () => {
    setOpenHistory(null);
  };

  const handleRoughEstimateClose = () => {
    setRoughEstimate(null);
  };

  const handleRoughEstimateComplete = () => {
    setRoughEstimate(null);
    fetchList();
  };

  React.useEffect(() => {
    fetchList();
  }, [pagination, tabs.selectedTab, dateState, searchState, statusParam]);

  React.useEffect(() => {
    if (tableRef.current && !isInitialLoad.current) {
      const topOffset = 90; // Adjust this value as needed
      const elementPosition =
        tableRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - topOffset,
        behavior: "smooth",
      });
    } else {
      isInitialLoad.current = false;
    }
  }, [statusParam]);

  React.useEffect(() => {
    return () => {
      dispatch(clearLeadsState());
    };
  }, []);

  return (
    <Box ref={tableRef}>
      <DataTableV2 {...leadsTableProps} />
      {openView && (
        <ViewLeadDetails
          open={true}
          lead={openView}
          onClose={() => setOpenView(null)}
        />
      )}

      {openWhatsapp && (
        <ViewWhatsappDetails
          open={true}
          onClose={() => setOpenWhatsapp(null)}
          leadDetails={openWhatsapp}
        />
      )}

      <DialerCallDialog
        open={dialerState.open}
        type={dialerState.type}
        message={dialerState.message}
        onClose={closeDialog}
      />

      {openEdit && (
        <EditLeadDetails
          open={true}
          title="Edit Lead Details"
          leadDetails={openEdit}
          onClose={() => setOpenEdit(null)}
          onComplete={(data: ILead) => {
            setOpenEdit(null);
            fetchList();
          }}
        />
      )}
      {openQuickEdit && (
        <QuickEditLead
          leadDetails={openQuickEdit}
          open={true}
          onClose={() => setOpenQuickEdit(null)}
        />
      )}

      {openRoughEstimate && (
        <RightPanel
          open={true}
          heading={`${openRoughEstimate.name_of_guest}'s Rough Estimate Details`}
          width="80%"
          onClose={handleRoughEstimateClose}
        >
          <ManageRoughEstimate
            leadUUID={openRoughEstimate.leads_uuid || ""}
            initialLeadToRoughEstimate={openRoughEstimate}
            onSave={fetchList}
            isInvoiceView={true}
          />
        </RightPanel>
      )}

      {openHistory && (
        <ViewHistoryDetailsRightPanel
          open={true}
          onClose={() => handleCloseHistory()}
          moduleInformation={{
            moduleId: openHistory.leads_uuid,
            moduleName: MODULE_NAMES.LEADS,
            subModuleName: MODULE_NAMES.LEADS,
            refColumnName: "leads_uuid",
          }}
        />
      )}

      {openViewLeadFoodMenuRightPanel && (
        <OrderProvider
          leadUuid={openViewLeadFoodMenuRightPanel.leads_uuid || ""}
        >
          <ViewLeadFoodMenuRightPanel
            selectedLeadData={openViewLeadFoodMenuRightPanel}
            open={true}
            leadUuid={openViewLeadFoodMenuRightPanel.leads_uuid || ""}
            multipleEventsUuid={
              openViewLeadFoodMenuRightPanel.multiple_events_uuid || ""
            }
            onClose={() => setOpenViewLeadFoodMenuRightPanel(null)}
          />
        </OrderProvider>
      )}
    </Box>
  );
};
